<template>
	<div class=" animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 图片 -->
		<el-image class="pbg" :src="require('@/static/icon79.png')"></el-image>
		<!-- 标题 -->
		<div class="pTit f-bct">
			<div class="txt">{{moniName}}&ensp;考试</div>
			<div class="time f-ct">
				<el-image :src="require('@/static/icon85.png')"></el-image>
				<p class="t1">剩余时间</p>
				<p class="t2">{{TimeObj.hours}}:{{TimeObj.minutes}}:{{TimeObj.seconds}}</p>
			</div>
		</div>
		<!-- 答题卡 -->
		<div class="question f-bct">
			<!-- 答题区 -->
			<div class="l">
				<div class="qtit f-bct">
					<div class="type">总题数</div>
					<div class="nub">{{questionIdx+1}}<span> / {{questionList.length}}</span></div>
				</div>
				<div class="qcon" style="position: relative;" v-if="questionList.length">
					
					<el-image
					v-if="questionList[questionIdx].picture"
					style="position: absolute;top: 0.2rem;right: 0.3rem;width: 2.6rem;"
					:src="questionList[questionIdx].picture"></el-image>
					
					<div class="f-bct">
					<div class="qtxt" v-if="questionList[questionIdx].type==1"><span style="font-weight: 600;padding-right: 2px;">{{questionIdx*1+1}}.</span>{{questionList[questionIdx].question}}（单选题）</div>
					<div class="qtxt" v-if="questionList[questionIdx].type==2"><span style="font-weight: 600;padding-right: 2px;">{{questionIdx*1+1}}.</span>{{questionList[questionIdx].question}}（多选题）</div>
					<div class="qtxt" v-if="questionList[questionIdx].type==3"><span style="font-weight: 600;padding-right: 2px;">{{questionIdx*1+1}}.</span>{{questionList[questionIdx].question}}（判断题）</div>
					<div class="qtxt1 f-ct" @click="changeScang()">
						<el-image v-if="questionList[questionIdx].isShoucang" class="i1" :src="require('@/static/icon88.png')"></el-image>
						<el-image v-else class="i1" :src="require('@/static/icon90.png')"></el-image>
						<p>稍后作答</p>
					</div>
					</div>
					
					<div class="qselList">
						<template v-for="(itm,idx) in questionList[questionIdx].optionList">
							<div class="selItm f-ct" @click="selDa(itm,idx)" :class="itm.isSel?'status2':''">
								<div class="nub f-ct">
									<span>{{itm.letter}}</span>
								</div>
								<div class="txt f-bct">
									<span>{{itm.option}}</span>
									<!-- {{itm.isSel}} -->
									<el-image class="i1" :src="require('@/static/icon80.png')"></el-image>
									<el-image class="i2" :src="require('@/static/icon81.png')"></el-image>
								</div>
							</div>
						</template>
					</div>
					<div class="qselBtn f-bct">
						<div class="f-ct">
							<div class="btn b2" @click="shangTi" v-if="questionIdx>0">上一题</div>
							<div class="btn b1" @click="nextTi" v-if="(questionIdx+1)<questionList.length">下一题</div>
						</div>
						<div class="btn b4" @click="courseOrderExamsubmitQD" v-if="questionList.length==(questionIdx+1)">提交考卷</div>
					</div>
				</div>
			</div>
			<!-- 答题卡 -->
			<div class="r">
				<!-- 标题 -->
				<div class="rtitBox f-bct">
					<div class="tit">答题卡</div>
					<div class="tips f-ct">
						<div class="itm f-ct">
							<span>答题中</span>
							<el-image :src="require('@/static/icon76.png')"></el-image>
						</div>
						<div class="itm f-ct">
							<span>已答题</span>
							<el-image :src="require('@/static/icon84.png')"></el-image>
						</div>
					</div>
				</div>
				<!-- 答题卡列表 -->
				<div class="cardList">
					
					<template v-if="typeIdx1!=-1">
						<div class="cardTit f-ct">
							<div>选择题<span>({{typeIdx1+1}})</span></div>
						</div>
						<div class="nublist f-ct">
							<template v-if="index<=typeIdx1" v-for="(item,index) in questionList">
								<div @click="questionIdx=index" class="itm status1" v-if="index==questionIdx">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm status4" v-else-if="item.isAnswer">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm status5" v-else-if="item.isShoucang">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm" v-else>{{index+1}}</div>
							</template>
						</div>
					</template>
					
					<template v-if="typeIdx2!=-1">
						<div class="cardTit f-ct">
							<div>多择题<span>({{typeIdx2+1}})</span></div>
						</div>
						<div class="nublist f-ct">
							<template v-if="index>typeIdx1&&index<=typeIdx4" v-for="(item,index) in questionList">
								<div @click="questionIdx=index" class="itm status1" v-if="index==questionIdx">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm status4" v-else-if="item.isAnswer">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm status5" v-else-if="item.isShoucang">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm" v-else>{{index+1}}</div>
							</template>
						</div>
					</template>
	
					<template v-if="typeIdx3!=-1">
						<div class="cardTit f-ct">
							<div>判断题<span>({{typeIdx3+1}})</span></div>
						</div>
						<div class="nublist f-ct">
							<template v-if="index>typeIdx4" v-for="(item,index) in questionList">
								<div @click="questionIdx=index" class="itm status1" v-if="index==questionIdx">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm status4" v-else-if="item.isAnswer">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm status5" v-else-if="item.isShoucang">{{index+1}}</div>
								<div @click="questionIdx=index" class="itm" v-else>{{index+1}}</div>
							</template>
						</div>
					</template>
					
				</div>
			</div>
		</div>
		<!-- 提示框 考试成功合格 -->
		<div class="maskBg" v-if="hbSubmit"></div>
		<div class="subTips" v-if="hbSubmit">
			<el-image class="icon" :src="require('@/static/icon71.png')"></el-image>
			<div class="t1">考试完成</div>
			<div class="t2">考试分数:{{submitData.score}}分，{{submitData.isPass?'及格':'不及格'}}</div>
			<!-- <div class="t2">考试分数:98分</div> -->
			<div class="btnBox f-ct">
				<div class="b1" @click="back()">返回我的考试</div>
			</div>
		</div>
		<!-- 提示框 请再接再厉 -->
		<div class="maskBg" v-if="hbSubmitN"></div>
		<div class="subTips" v-if="hbSubmitN">
			<el-image class="icon" :src="require('@/static/icon86.png')"></el-image>
			<div class="t1">考试不及格！ 请再接再厉</div>
			<div class="t2">考试分数:{{submitData.score}}分</div>
			<!-- <div class="t3">及格分60分</div> -->
			<div class="btnBox f-ct">
				<div class="b1" @click="back()">返回详情</div>
				<div class="b2" @click="backNub(0)">再次考试</div>
			</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { courseOrderExamcreate,
courseOrderExamDetail,
courseOrderExamsubmitExamRecord,
courseOrderExamsubmit,
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
let iv;
export default {
	data(){
		return {
			moniName:'',
			hbSubmit:false,
			hbSubmitN:false,
			id:0,
			// 数据
			exam:'',
			questionList:[],
			questionIdx:0,
			// 数据分类idx
			typeIdx1:0,
			typeIdx2:0,
			typeIdx3:0,
			typeIdx4:0,
			// 结算
			submitData:'',
			// 倒计时
			TimeObj:'',
		}
	},
	mounted() {
		this.moniName = localStorage.getItem('kaoName')
		// 参数
		this.id = this.$route.query.id
		// 获取详情
		this.courseOrderExamcreate()
	},
	methods:{
		// 修改收藏
		changeScang(){
			var item = this.questionList[this.questionIdx]
			item.isShoucang = !item.isShoucang
			this.$set(this.questionList,this.questionIdx,item)
		},
		// 提交试卷
		courseOrderExamsubmitQD(){
			var that = this
			this.$confirm('确定提交试卷, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
				console.log(1)
				that.courseOrderExamsubmit()
			 //  this.$message({
				// type: 'success',
				// message: '删除成功!'
			 //  });
			}).catch(() => {
				console.log(2)
				// that.courseOrderExamsubmit()
			 //  this.$message({
				// type: 'info',
				// message: '已取消删除'
			 //  });          
			});
		},
		async courseOrderExamsubmit(){
			var questionOptionList = []
			this.questionList.forEach((item)=>{
				var optionIds = []
				item.optionList.forEach((itm)=>{
					if(itm.isSel){
						optionIds.push(itm.id)
					}
				})
				questionOptionList.push({
					questionId:item.id,
					optionIds
				})
			})
			// console.log(questionOptionList)
			// return
			var data = {
				examId:this.exam.id,
				questionOptionList
			}
			let res = await courseOrderExamsubmit(data);
			if(res.code==200){
				this.hbSubmit = true
				// if(res.data.isPass){
				// 	this.hbSubmit = true
				// }else{
				// 	this.hbSubmitN = true
				// }
				this.submitData = res.data
				
				// this.Tips(res.msg,'success')
				// setTimeout(()=>{
				// 	this.back()
				// })
			}else{this.Tips(res.msg,'error')}
		},
		// 上一题
		shangTi(){
			if(this.questionIdx){
				this.questionIdx--
			}
		},
		// 下一题
		nextTi(){
			var item = {...this.questionList[this.questionIdx]}
			if(this.questionIdx+1<this.questionList.length){
				this.questionIdx++
			}
			this.courseOrderExamsubmitExamRecord(item)
		},
		// 存储数据
		async courseOrderExamsubmitExamRecord(item){
			var questionOptionIds = []
			item.optionList.forEach((i)=>{
				if(i.isSel){
					questionOptionIds.push(i.id)
				}
			})
			var data = {
				courseOrderExamId:this.exam.id,
				courseOrderId:this.id,
				questionId:item.id,
				questionOptionIds,
			}
			let res = await courseOrderExamsubmitExamRecord(data);
			if(res.code==200){
				
			}else{this.Tips(res.msg,'error')}
		},
		// 选择答案
		selDa(itm,idx){
			var item = this.questionList[this.questionIdx]
			if(item.type==1||item.type==3){
				item.optionList.forEach((i)=>{
					i.isSel = false
				})
			}
			item.isAnswer = true
			// console.log(item.optionList[idx])
			item.optionList[idx].isSel = !item.optionList[idx].isSel
			this.$set(this.questionList,this.questionIdx,item)
		},
		// 获取详情
		async courseOrderExamcreate(){
			let res = await courseOrderExamcreate({
				courseOrderId:this.id,
			});
			if(res.code==200){
				this.courseOrderExamDetail(res.data.id)
			}else{this.Tips(res.msg,'error')}
		},
		async courseOrderExamDetail(examId){
			let res = await courseOrderExamDetail({examId});
			if(res.code==200){
				this.exam = res.data.exam
				var TimeObj = this.getTimeLeft(this.exam.expireTime)
				iv = setInterval(()=>{
					this.TimeObj = this.getTimeLeft(this.exam.expireTime)
					if(this.TimeObj===false){
						clearInterval(iv)
						this.Tips('作答结束，已为您自动交卷','error')
						this.courseOrderExamsubmit()
					}
				},1000)
				res.data.questionList.forEach((item)=>{
					item.isAnswer = false
					item.isShoucang = false
					item.optionList.forEach((itm)=>{
						itm.isSel = false
						// itm.option = [itm.option.substring(0,1),itm.option.substring(2)]
					})
				})
				
				var arr1 = []
				var arr2 = []
				var arr3 = []
				res.data.questionList.forEach((item,index)=>{
					if(item.type==1){
						arr1.push(item)
					}
					if(item.type==2){
						arr2.push(item)
					}
					if(item.type==3){
						arr3.push(item)
					}
				})
				res.data.questionList = [...arr1,...arr2,...arr3]
				this.typeIdx1 = arr1.length-1
				this.typeIdx2 = arr2.length-1
				this.typeIdx3 = arr3.length-1
				this.typeIdx4 = this.typeIdx1 + this.typeIdx2+1
				
				var examRecordList = res.data.examRecordList
				// 处理存储数据
				if(examRecordList.length){
					res.data.questionList.forEach((item,index)=>{
						examRecordList.forEach((eitm)=>{
							if(item.id==eitm.questionId){
								// this.questionIdx = index
								item.optionList.forEach((itm)=>{
									if(eitm.questionOptionIds.indexOf(itm.id)==-1){
										
									}else{
										itm.isSel = true
										item.isAnswer = true
									}
								})
							}
						})
					})
					// this.questionIdx = this.questionIdx*1+1
				}
				
				
				
				this.questionList = res.data.questionList
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.pbg{
	width: 100%;
	height: 251px;
	position: fixed;
	top: 0;
	left: 0;
}
.pTit{
	padding-top: 52px;
	padding-bottom: 44px;
	width: 1595px;
	margin: auto;
	position: relative;
	z-index: 2;
	.txt{
		font-size: 24px;
		color: #fff;
		font-weight: bold;
	}
	.back{
		p{
			font-size: 16px;
			color: #fff;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
	.time{
		width: 240px;
		height: 48px;
		justify-content: center;
		border-radius: 8px;
		background: #FFFFFF1A;
		.el-image{
			width: 20px;
			height: 20px;
			margin-right: 11px;
		}
		.t1{
			font-size: 14px;
			color: #FFFFFF;
		}
		.t2{
			padding-left: 9px;
			font-size: 20px;
			font-weight: bold;
			color: #fff;
		}
	}
}
.question{
	width: 1595px;
	margin: auto;
	position: relative;
	z-index: 2;
	margin-bottom: 40px;
	align-items: stretch;
	.l{
		width: 1203px;
		border-radius: 20px;
		background: #fff;
		.qtit{
			border-radius: 20px 20px 0 0;
			height: 103px;
			width: 100%;
			padding-left: 32px;
			padding-right: 22px;
			background: #FAFBFC;
			.type{
				font-size: 24px;
				font-weight: bold;
			}
			.nub{
				font-size: 18px;
				font-weight: bold;
				span{
					font-weight: normal;
					color: #9A9DA7;
				}
			}
		}
		.qcon{
			padding: 32px;
			.qtxt{
				font-size: 16px;
				color: #2F3541;
				margin-bottom: 32px;
				line-height: 28px;
			}
			.qtxt1{
				p{
					font-size: 14px;
					color: #3B6492;
				}
				.el-image{
					width: 16px;
					margin-right: 8px;
				}
				// margin-bottom: 32px;
			}
			.qselList{
				.selItm{
					border: 2px solid #E8EDF4;
					border-radius: 6px;
					width: 500px;
					// height: 48px;
					align-items: stretch;
					margin-bottom: 16px;
					.nub{
						width: 26px;
						background: #F5F9FF;
						font-size: 14px;
						color: #545964;
						justify-content: center;
					}
					.txt{
						border-left: 2px solid #E8EDF4;
						width: calc(100% - 26px);
						font-size: 14px;
						color: #545964;
						padding: 10px 15px;
						span{
							display: block;
							width: calc(100% - 34px);
						}
						.el-image{
							width: 24px;
							height: 24px;
							display: none;
						}
					}
				}
				.status1{
					border: 2px solid #FF5F5A;
					.nub{
						background: #FF5F5A;
						color: #fff;
					}
					.txt{
						border-left: 2px solid #FF5F5A;
						.i1{
							display: block;
						}
					}
				}
				.status2{
					border: 2px solid #3B6492;
					.nub{
						background: #3B6492;
						color: #fff;
					}
					.txt{
						border-left: 2px solid #3B6492;
						.i2{
							display: block;
						}
					}
				}
			}
			.qselBtn{
				margin-top: 360px;
				.btn{
					min-width: 148px;
					height: 45px;
					line-height: 43px;
					padding: 0 50px;
					border-radius: 8px;
					font-size: 16px;
					margin-right: 16px;
					cursor: pointer;
				}
				.b1{
					background: #3B6492;
					border: 1px solid #3B6492;
				}
				.b2{
					background: #fff;
					color: #2F3541;
					border: 1px solid #E8EDF4;
				}
				.b3{
					background: #E9F6FF;
					color: #3B6492;
					border: 1px solid #E9F6FF;
				}
				.b4{
					background: #FF5F5A;
					color: #fff;
					border: 1px solid #FF5F5A;
				}
			}
		}
	}
	.r{
		width: 345px;
		border-radius: 20px;
		background: #fff;
		.rtitBox{
			border-radius: 20px 20px 0 0;
			height: 103px;
			width: 100%;
			padding-left: 32px;
			padding-right: 22px;
			background: #FAFBFC;
			.tit{
				font-size: 24px;
				font-weight: bold;
			}
			.tips{
				.itm{
					margin-left: 12px;
					span{
						font-size: 14px;
					}
					.el-image{
						width: 16px;
						height: 16px;
						margin-left: 4px;
					}
				}
			}
		}
		.cardList{
			padding: 0 20px;
			padding-right: 4px;
			height: 750px;
			overflow-y: scroll;
			margin-bottom: 40px;
			.cardTit{
				padding-top: 20px;
				padding-right: 16px;
				.el-image{
					width: 16px;
					height: 16px;
					margin-right: 9px;
				}
				div{
					font-size: 16px;
					color: #2F3541;
					span{
						font-size: 14px;
						color: #9A9DA7;
					}
				}
			}
			.nublist{
				.itm{
					width: 36px;
					height: 36px;
					font-size: 14px;
					color: #878792;
					border: 2px solid #E8EDF4;
					line-height: 32px;
					text-align: center;
					margin-right: 16px;
					margin-top: 16px;
					border-radius: 2px;
					cursor: pointer;
				}
				.status1{
					color: #3B6492;
					border: 2px solid #3B6492;
				}
				.status2{
					color: #fff;
					background: #3B6492;
					border: 2px solid #3B6492;
				}
				.status3{
					color: #fff;
					background: #FF5F5A;
					border: 2px solid #FF5F5A;
				}
				.status4{
					color: #9A9DA7;
					background: #DEE0E2;
					border: 2px solid #DEE0E2;
				}
				.status5{
					color: #fff;
					background: #dfaf00;
					border: 2px solid #dfaf00;
				}
			}
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 18px;
		color: #FF5F5A;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.t3{
		font-size: 14px;
		color: #999999;
		padding: 0 27px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
		span{
			color: #2F3541;
		}
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>